export const getBreakdownStepIndex = (acrValues: string[]): number => {
  const breakdownStepPattern = /^breakdown_tunnel_step(\d+)$/;
  const breakdownStep = acrValues.find((value) => breakdownStepPattern.test(value));
  if (breakdownStep) {
    const match = breakdownStep.match(breakdownStepPattern);
    return match ? parseInt(match[1], 10) : 3;
  }
  return 3;
};
